<template>
  <div>
    <el-row type="flex" justify="end" class="desc-table-top">
      <el-button size="small" style="margin-right: 2px;" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper ref="hostConfigTable" border :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable" :header-cell-class-name="headerCellClassName">
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { mapGetters } from 'vuex';
import perfApi from '@/api/virtual/performance/config';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { isEmpty, isNil, isEqual } from 'lodash';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
// const hyperFilters = [{ text: '사용', value: '사용' }, { text: '사용 안 함', value: '사용 안 함' }];

export default {
  name: 'WHostConfigTable',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    const logicalColumns = [
      { label: '호스트 명', prop: 'objName', scopedSlot: 'obj-name-slot', remoteProp: 'objName', width: 140, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '가상화센터 명', prop: 'virtualcenterName', remoteProp: 'virtualcenterName', sortable: true, searchable: true, formatter: this.virtualCenterNameFormatter },
      { label: 'IP', prop: 'ipaddress', remoteProp: 'ipaddress', width: 140, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: 'VM 수', prop: 'VHO_COMMON/VM_COUNT', remoteProp: 'VHO_COMMON/VM_COUNT', width: 80, formatter: this.getTableValueAfterCheckEmpty },
      { label: '제조업체', prop: 'VHO_SYSTEM/MANUFACTURING_FIRM', remoteProp: 'VHO_SYSTEM/MANUFACTURING_FIRM', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '모델', prop: 'VHO_SYSTEM/MODEL_NAME', remoteProp: 'VHO_SYSTEM/MODEL_NAME', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '프로세서 유형', prop: 'VHO_PROCESSOR/PROCESSOR_TYPE', remoteProp: 'VHO_PROCESSOR/PROCESSOR_TYPE', width: 320, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '프로세서 소켓 수', prop: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT', remoteProp: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT', formatter: this.getTableValueAfterCheckEmpty },
      { label: '소켓당 코어 수', prop: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET', remoteProp: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET', formatter: this.getTableValueAfterCheckEmpty },
      { label: '논리 프로세서 수', prop: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT', remoteProp: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT', formatter: this.getTableValueAfterCheckEmpty },
      { label: '하이퍼 스레딩', prop: 'VHO_PROCESSOR/HYPER_THREADING_MODE', remoteProp: 'VHO_PROCESSOR/HYPER_THREADING_MODE', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
    ];
    const physicalColumns = [
      { label: '호스트 명', prop: 'objName', scopedSlot: 'obj-name-slot', remoteProp: 'objName', width: 140, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: 'IP', prop: 'ipaddress', remoteProp: 'ipaddress', width: 140, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: 'VM 수', prop: 'VHO_COMMON/VM_COUNT', remoteProp: 'VHO_COMMON/VM_COUNT', width: 80, formatter: this.getTableValueAfterCheckEmpty },
      { label: '제조업체', prop: 'VHO_SYSTEM/MANUFACTURING_FIRM', remoteProp: 'VHO_SYSTEM/MANUFACTURING_FIRM', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '모델', prop: 'VHO_SYSTEM/MODEL_NAME', remoteProp: 'VHO_SYSTEM/MODEL_NAME', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '프로세서 유형', prop: 'VHO_PROCESSOR/PROCESSOR_TYPE', remoteProp: 'VHO_PROCESSOR/PROCESSOR_TYPE', width: 320, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      { label: '프로세서 소켓 수', prop: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT', remoteProp: 'VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT', formatter: this.getTableValueAfterCheckEmpty },
      { label: '소켓당 코어 수', prop: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET', remoteProp: 'VHO_PROCESSOR/CPU_CORES_PER_SOCKET', formatter: this.getTableValueAfterCheckEmpty },
      { label: '논리 프로세서 수', prop: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT', remoteProp: 'VHO_PROCESSOR/CPU_LOGICAL_PROCESSOR_COUNT', formatter: this.getTableValueAfterCheckEmpty },
      { label: '하이퍼 스레딩', prop: 'VHO_PROCESSOR/HYPER_THREADING_MODE', remoteProp: 'VHO_PROCESSOR/HYPER_THREADING_MODE', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
    ];
    return {
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [],
      EMPTY_TEXT,
      logicalColumns,
      physicalColumns,
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedVmsObjtypeIds']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.hostConfigTable === undefined) {
          this.$nextTick(() => {
            this.$refs.hostConfigTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.hostConfigTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.hostConfigTable.getParameter();
        const params = {
          ...tableParams,
          treeType: this.treeType,
          subType: this.selectedNode.subType,
          hypervisorType: this.selectedNode.hypervisorType,
          objypeId: this.selectedNode.objtypeId,
          isGroup: true,
          objtypeIds: ['VHO'],
        };

        this.columns = this.logicalColumns;
        if (isEqual(this.treeType, 'logical')) {
          params.managegroupIds = this.selectedNode.childManagegroupIds;
        } else {
          params.objId = this.selectedNode.obj ? this.selectedNode.obj.objId : null;
          params.objtypeId = this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId;
          params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
          // this.columns = this.physicalColumns;
        }

        perfApi.getGroupConfigInfoForObjtype(params).then((response) => {
          if (response.data.success) {
            this.tableDatas = response.data.data;
            this.tableTotal = response.data.total;
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onChangeTable() {
      this.loadStore();
    },
    // 장비 목록 엑셀 출력
    onClickExportExcel() {
      const tableParams = this.$refs.hostConfigTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...tableParams,
        treeType: this.treeType,
        subType: this.selectedNode.subType,
        hypervisorType: this.selectedNode.hypervisorType,
        objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
        virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
        managegroupIds: this.selectedNode.managegroupId ? this.selectedNode.childManagegroupIds : null,
        objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
        objtypeIds: ['VHO'],
        isGroup: true,
        vmsGroupTableFlag: this.selectedNode.managegroupId ? 'logical' : 'physical',
      };
      perfApi.exportVmsConfigInfoTargetDeviceList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    // 논리그룹 - 성능/구성 테이블 가상화 센터명 컬럼 formatter
    virtualCenterNameFormatter(row) {
      let result = '';
      if (row.virtualcenterName === '' || isNil(row.virtualcenterName)) {
        result += EMPTY_TEXT;
      } else {
        result += row.virtualcenterName;
      }
      if (row.basicinfoSubname === '' || isNil(row.basicinfoSubname)) {
        result += ` (${EMPTY_TEXT})`;
      } else {
        result += ` (${row.basicinfoSubname})`;
      }
      return result;
    },
    headerCellClassName() {
      return 'expand-column-header-style';
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    convertValuByUnit,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/config/components/HostConfigTable.vue